import { render, staticRenderFns } from "./creatTemplates.vue?vue&type=template&id=10d1570a&scoped=true"
import script from "./creatTemplates.vue?vue&type=script&lang=js"
export * from "./creatTemplates.vue?vue&type=script&lang=js"
import style0 from "./creatTemplates.vue?vue&type=style&index=0&id=10d1570a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d1570a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10d1570a')) {
      api.createRecord('10d1570a', component.options)
    } else {
      api.reload('10d1570a', component.options)
    }
    module.hot.accept("./creatTemplates.vue?vue&type=template&id=10d1570a&scoped=true", function () {
      api.rerender('10d1570a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/deliverGoods/freightSet/creatTemplates.vue"
export default component.exports